import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'linaria';
import cls from '../../utils/class_strings/class_strings';

const paginationStyles = css`
  align-items: center;
  display: flex;
`;

const nextPrevStyles = css`
  flex-shrink: 0;
  margin-top: 0.5em;
`;

const paginationListStyles = css`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const paginationListItemStyles = css`
  margin: 0.5em 0.5em 0;
`;

const Pagination = ({
  className,
  currentPage,
  gotoLabel,
  href,
  nextLabel,
  numberOfItems = 0,
  pageSize,
  previousLabel,
  setPage,
  showNextPrev,
  type,
  ...DOM
}) => {
  const numberOfPages = Math.ceil(numberOfItems / pageSize);
  const re = /\$\{page\}/gi;
  const rows = [];

  // Anchor/Button Component
  const PaginationAnchor = ({ href: h, ...rest }) => {
    const Tag = type === 'a' ? 'a' : 'button';
    let p = {
      ...rest,
      onClick(evt) {
        setPage(h, evt);
      },
    };

    if (type === 'a') {
      const hc = (h !== undefined && href.replace(re, h)) || undefined;

      // If no href, remove onClick
      if (!hc) {
        p.onClick = undefined;
      }

      p = {
        ...p,
        'aria-current': h === currentPage || undefined,
        href: hc,
      };
    } else {
      p = {
        ...p,
        disabled: h === undefined || h === currentPage || undefined,
        type: 'button',
      };
    }

    return <Tag {...p} />;
  };

  // Creat Rows
  for (let i = 1; i <= numberOfPages; i++) {
    rows.push(
      <li className={paginationListItemStyles} key={i}>
        <PaginationAnchor aria-label={gotoLabel.replace(re, i)} href={i}>
          {i}
        </PaginationAnchor>
      </li>
    );
  }
  //

  return (
    <nav className={cls(className, paginationStyles)} role="navigation" {...DOM}>
      {showNextPrev && (
        <PaginationAnchor className={nextPrevStyles} href={currentPage > 1 ? currentPage - 1 : undefined}>
          {previousLabel}
        </PaginationAnchor>
      )}
      <ol className={paginationListStyles}>{rows}</ol>
      {showNextPrev && (
        <PaginationAnchor className={nextPrevStyles} href={currentPage < numberOfPages ? currentPage + 1 : undefined}>
          {nextLabel}
        </PaginationAnchor>
      )}
    </nav>
  );
};

Pagination.defaultProps = {
  gotoLabel: 'Goto Page ${page}',
  href: '?page=${page}',
  nextLabel: 'Next Page',
  pageSize: 10,
  previousLabel: 'Previous Page',
  showNextPrev: true,
  type: 'a',
};

Pagination.propTypes = {
  'aria-label': PropTypes.string.isRequired,
  className: PropTypes.string,
  currentPage: PropTypes.number.isRequired,
  gotoLabel: PropTypes.string,
  href: PropTypes.string,
  nextLabel: PropTypes.string,
  numberOfItems: PropTypes.number.isRequired,
  pageSize: PropTypes.number,
  previousLabel: PropTypes.string,
  setPage: PropTypes.func.isRequired,
  showNextPrev: PropTypes.bool,
  type: PropTypes.string,
};

export default Pagination;
